import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = [ "destination" ]

  async send(event) {
    const btn = event.currentTarget

    // When a destination picker is present (Discord), a channel must be chosen;
    // we never auto-post to a default.
    let body
    if (this.hasDestinationTarget) {
      const destination = this.destinationTarget.value
      if (!destination) {
        window.toast("Pick a channel to test first.", { kind: "error" })
        return
      }
      body = JSON.stringify({ destination })
    }

    btn.disabled = true
    const original = btn.innerHTML
    btn.innerHTML = '<i class="bi bi-hourglass-split" aria-hidden="true"></i> Sending...'

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json",
          ...(body ? { "Content-Type": "application/json" } : {})
        },
        body
      })
      const data = await response.json()
      if (response.ok) {
        window.toast(data.message, { kind: "success" })
      } else {
        window.toast(data.error || "Test failed.", { kind: "error" })
      }
    } catch {
      window.toast("Network error. Try again.", { kind: "error" })
    } finally {
      btn.disabled = false
      btn.innerHTML = original
    }
  }
}
